<section class="main-section">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Security</li>
        </ol>
    </nav>
    <div class="row mt-3">
        <div class="col">
            <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
                <div class="row mt-3">
                    <div class="col">
                        <h2 class="text-black ml-1 mb-3">Security Groups</h2>
                        <table class="table table-stripe" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" width="100%">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Assign Types</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody class="table-body-custom">
                                <tr *ngFor="let g of groupList">
                                    <td>{{g.groupId}}</td>
                                    <td>{{g.groupCode}}</td>
                                    <td>{{g.groupDescription}}</td>
                                    <td><a routerLink="/admin/securityType/{{g.groupCode}}/{{g.organizationId}}" *ngIf="g.status === 'ACTIVE'">Configure</a></td>
                                    <td>
                                        <a>
                                            <div class="toggle-2">
                                                <input type="checkbox" name="onoffswitch" id="customSwitch_{{g.groupCode}}" class="custom-control-input" (click)="changeStatus(g)" [checked]="g.status==='ACTIVE'" class="checkbox" />
                                                <label for="customSwitch_{{g.groupCode}}" class="toggle">
                    <span>ON</span><span>OFF</span>
                  </label>
                                            </div>
                                            <!--
                <div class="custom-control custom-switch">
                  <input type="checkbox"  class="custom-control-input" (click)="changeStatus(g)" id="customSwitch_{{g.groupCode}}" [checked]="g.status==='ACTIVE'">
                  <label class="custom-control-label" for="customSwitch_{{g.groupCode}}"> </label>
                </div>
-->
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr *ngIf="groupList?.length===0|| !groupList?.length">
                                    <td colspan="5" class="text-center">No matching records found</td>
                                </tr>
                            </tfoot>
                        </table>
                        <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!groupNameError">{{groupNameError}}</div>
                        <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!groupDescError">{{groupDescError}}</div>
                    </div>
                </div>
            </div>
            <div class="inner-box d-block d-sm-none">
                <div class="row mt-3">
                    <div class="col">
                        <h2 class="text-black ml-1 mb-3">Security Groups</h2>
                        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Assign Types</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let g of groupList">
                                    <td><b class=" tablesaw-cell-label">Id</b>
                                        <span class="tablesaw-cell-content">{{g.groupId}}</span></td>
                                    <td><b class=" tablesaw-cell-label">Name</b>
                                        <span class="tablesaw-cell-content">{{g.groupCode}}</span></td>
                                    <td><b class=" tablesaw-cell-label">Description</b>
                                        <span class="tablesaw-cell-content">{{g.groupDescription}}</span></td>
                                    <td>
                                        <b class=" tablesaw-cell-label">Assign Types</b>
                                        <span class="tablesaw-cell-content"><a routerLink="/admin/securityType/{{g.groupCode}}/{{g.organizationId}}" *ngIf="g.status === 'ACTIVE'">Configure</a></span></td>
                                    <td><b class=" tablesaw-cell-label">Status</b>
                                        <span class="tablesaw-cell-content">
                <a>
                  <div class="custom-control custom-switch">
                    <input type="checkbox"  class="custom-control-input" (click)="changeStatus(g)" id="customSwitch_{{g.groupCode}}" [checked]="g.status==='ACTIVE'">
                    <label class="custom-control-label" for="customSwitch_{{g.groupCode}}"> </label>
                  </div>
                </a>
                </span></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!groupNameError">{{groupNameError}}</div>
                        <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!groupDescError">{{groupDescError}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
